import { render, staticRenderFns } from "./TestimonialDetailsPopup.vue?vue&type=template&id=42cb0ac7"
import script from "./TestimonialDetailsPopup.vue?vue&type=script&lang=js"
export * from "./TestimonialDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports